var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5396,
    cy: 14.1665,
    r: 14.1665,
    fill: "#4B84F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7530_45133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.205 10.2658L15.1718 8.25653C14.9383 8.16449 14.6784 8.16449 14.4448 8.25653L9.41168 10.2658C9.22963 10.3385 9.07365 10.4641 8.96396 10.6263C8.85427 10.7885 8.79594 10.9799 8.79652 11.1756V19.1681C8.79799 19.4267 8.90157 19.6743 9.08479 19.8572C9.26801 20.04 9.51608 20.1434 9.77519 20.1449H10.7539C10.828 20.1449 10.8991 20.1155 10.9516 20.0632C11.004 20.0108 11.0335 19.9398 11.0335 19.8658V13.7263C11.0335 13.6523 11.0629 13.5813 11.1154 13.529C11.1678 13.4766 11.2389 13.4472 11.3131 13.4472H18.3036C18.3777 13.4472 18.4488 13.4766 18.5013 13.529C18.5537 13.5813 18.5832 13.6523 18.5832 13.7263V19.8658C18.5832 19.9398 18.6126 20.0108 18.6651 20.0632C18.7175 20.1155 18.7886 20.1449 18.8628 20.1449H19.8415C20.1006 20.1434 20.3487 20.04 20.5319 19.8572C20.7151 19.6743 20.8187 19.4267 20.8201 19.1681V11.1756C20.8207 10.9799 20.7624 10.7885 20.6527 10.6263C20.543 10.4641 20.387 10.3385 20.205 10.2658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4858 16.5171H13.1304C12.8987 16.5171 12.7109 16.7045 12.7109 16.9357V19.7264C12.7109 19.9576 12.8987 20.145 13.1304 20.145H16.4858C16.7174 20.145 16.9052 19.9576 16.9052 19.7264V16.9357C16.9052 16.7045 16.7174 16.5171 16.4858 16.5171Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6421 33.8418L8.64209 25.8418H20.6421L14.6421 33.8418Z",
    fill: "#4B84F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7530_45133",
    x: 2.79652,
    y: 4.1875,
    width: 24.0236,
    height: 23.9575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0763889 0 0 0 0 0.353571 0 0 0 0 0.366667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7530_45133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7530_45133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.1f62c8f9837cec3cd89543519e1c0f1a.svg";
export { ForwardRef as ReactComponent };